/* drawlz-cart.js — Drawlz cart drawer, structural pass.
   Visual source: cart-drawer-mock_5.html.

   WHY THIS EXISTS. The theme renders each line as <tr class="cart-item"> with FOUR
   cells in this DOM order: media / details(name+price) / totals_alt(remove) /
   quantity(size + stepper). The mock needs name+remove on one line, then variant,
   then prices, then stepper-left with line-total-right. Size and the stepper live
   in a different cell from the price, so no amount of CSS can interleave them.
   This MOVES the existing nodes into the mock's order.

   IT NEVER CLONES OR REBUILDS INTERACTIVE NODES. The quantity stepper, the remove
   button and the name link are the theme's own elements, relocated with
   appendChild. cart.js and quantity-popover.js keep their references, so add /
   remove / quantity and the section re-render behave exactly as before.

   Everything re-runs on each cart re-render via a debounced MutationObserver,
   because Shopify replaces the drawer's innerHTML wholesale on every cart change.
   Each step is individually try/caught: a failure leaves the theme's own markup
   standing rather than a broken cart. */
(function () {
  'use strict';

  var DONE = 'dzcDone';

  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }
  function txt(n) { return n ? (n.textContent || '').trim() : ''; }

  /* ---------- 1. line items ---------- */
  function restructureItems(root) {
    var rows = root.querySelectorAll('tr.cart-item');
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      if (row.dataset[DONE]) continue;
      try {
        var details = row.querySelector('.cart-item__details');
        var removeCell = row.querySelector('.cart-item__totals_alt');
        var qtyCell = row.querySelector('.cart-item__quantity');
        if (!details || !qtyCell) continue;

        var name = details.querySelector('.cart-item__name');
        var priceWrap = details.querySelector('.cart-item__price-wrapper');
        var sizeBlock = qtyCell.querySelector('.item_info_block');
        var stepper = qtyCell.querySelector('quantity-popover') ||
                      qtyCell.querySelector('.quantity-popover-wrapper') ||
                      qtyCell.querySelector('.quantity');
        var removeBtn = removeCell ? removeCell.querySelector('cart-remove-button') : null;

        var body = el('div', 'dzc-line');

        var top = el('div', 'dzc-line__top');
        if (name) top.appendChild(name);
        if (removeBtn) top.appendChild(removeBtn);
        body.appendChild(top);

        if (sizeBlock) {
          var v = el('div', 'dzc-line__var');
          v.appendChild(sizeBlock);
          body.appendChild(v);
        }
        if (priceWrap) {
          var p = el('div', 'dzc-line__price');
          p.appendChild(priceWrap);
          body.appendChild(p);
        }

        var foot = el('div', 'dzc-line__foot');
        if (stepper) foot.appendChild(stepper);
        var lt = el('span', 'dzc-line__total');
        var priceEl = priceWrap ? priceWrap.querySelector('.price') : null;
        var pText = txt(priceEl);
        lt.textContent = pText ? pText.split(' ').pop() : '';
        foot.appendChild(lt);
        body.appendChild(foot);

        details.appendChild(body);
        row.dataset[DONE] = '1';
      } catch (e) { /* leave this row as the theme rendered it */ }
    }
  }

  /* ---------- 2. savings block ---------- */
  function restructureSavings(root) {
    try {
      var block = root.querySelector('.drawer_discount_msg_header');
      if (!block || block.dataset[DONE]) return;
      var msg = block.querySelector('.drawer_offer_msg');
      if (!msg) return;

      var calc = block.querySelector('.drawer_discount_msg_calc');
      var pct = '';
      if (calc) {
        var tail = txt(calc).split('(').pop();
        if (tail && tail.indexOf('%') > -1) pct = tail.split(')')[0].trim();
      }

      /* No-savings state. The theme still renders this band, filled with
         settings.cart_bar_text_no_saving ("You've got the check out now!
         Drawlz!"), which reads as nonsense beside a savings tag. When there is
         nothing to save, hide the band rather than restyle it. */
      var savedNow = savedFromCalc(calc);
      if (savedNow === null || savedNow <= 0) {
        block.style.display = 'none';
        block.dataset[DONE] = '1';
        return;
      }

      var strong = msg.querySelector('strong');
      var amount = strong ? txt(strong) : '';
      var money = '';
      var parts = amount.split(' ');
      for (var i = 0; i < parts.length; i++) {
        if (parts[i].indexOf('$') > -1) money = parts[i].split('!').join('');
      }
      var eyebrow = txt(msg);
      if (amount) eyebrow = eyebrow.split(amount).join('');
      eyebrow = eyebrow.trim();
      while (eyebrow.length && '-:–—'.indexOf(eyebrow.charAt(eyebrow.length - 1)) > -1) {
        eyebrow = eyebrow.slice(0, -1).trim();
      }
      if (!eyebrow) eyebrow = 'You are saving';

      block.textContent = '';
      block.appendChild(el('span', 'dzc-save__seal',
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.6 13.4 13.4 20.6a2 2 0 0 1-2.8 0l-7.2-7.2a2 2 0 0 1-.6-1.4V4a1 1 0 0 1 1-1h7.6a2 2 0 0 1 1.4.6l7.2 7.2a2 2 0 0 1 0 2.8Z"/><circle cx="7.5" cy="7.5" r="1.2" fill="currentColor" stroke="none"/></svg>'));
      var col = el('div', 'dzc-save__txt');
      col.appendChild(el('span', 'dzc-save__eyebrow', eyebrow));
      var amtRow = el('div', 'dzc-save__amtrow');
      amtRow.appendChild(el('span', 'dzc-save__amt', money || amount));
      /* Percent deliberately not shown: the dollar figure alone is the stronger
         signal, and dropping it keeps the band to a single idea. `pct` is still
         derived above if it is ever wanted back. */
      col.appendChild(amtRow);
      col.appendChild(el('span', 'dzc-save__sub', 'Locked in — applied at checkout.'));
      block.appendChild(col);
      /* put the theme's hidden calc div back: footerNote() reads the saved
         amount out of it, and wiping the block had been deleting it. */
      if (calc) {
        calc.style.display = 'none';
        /* display:none already hides it visually, but it was still landing in the
           accessible text after the savings figure, so a screen reader read the
           raw maths aloud. */
        calc.setAttribute('aria-hidden', 'true');
        block.appendChild(calc);
      }
      block.dataset[DONE] = '1';
    } catch (e) {}
  }

  /* ---------- 3. footer "you saved" line ---------- */
  /* The hidden calc div prints: compare, price, 0, compare, SAVED, (pct).
     Returns the saved amount in dollars, or null if it cannot be read. */
  function savedFromCalc(calc) {
    if (!calc) return null;
    var parts = txt(calc).split('$').filter(function (x) { return x.trim(); });
    if (parts.length < 4) return null;
    var v = parseFloat(parts[parts.length - 1].split('(')[0].trim().split(',').join(''));
    return isNaN(v) ? null : v;
  }

  function footerNote(root) {
    try {
      var note = root.querySelector('.tax-note');
      if (!note || note.dataset[DONE]) return;
      var calc = root.querySelector('.drawer_discount_msg_calc');
      var sv = savedFromCalc(calc);
      if (sv === null || sv <= 0) return;   /* never print "You saved $0.00" */
      if (!calc) return;
      var chunks = txt(calc).split('$').filter(function (x) { return x.trim(); });
      if (chunks.length < 4) return;
      var saved = '$' + chunks[chunks.length - 1].split('(')[0].trim();
      if (saved.length < 2) return;
      var tag = el('span', 'dzc-saved', 'You saved ' + saved);
      note.insertBefore(document.createTextNode(' · '), note.firstChild);
      note.insertBefore(tag, note.firstChild);
      note.dataset[DONE] = '1';
    } catch (e) {}
  }

  /* ---------- 4. complete your order ---------- */
  function upsell(root) {
    var wrap = root.querySelector('.cart-drawer__footer_product_recom');
    if (!wrap || wrap.dataset[DONE]) return;
    wrap.dataset[DONE] = '1';
    try {
      var head = wrap.querySelector('.related-products__heading');
      var track = wrap.querySelector('.inner-wrapper');
      if (head) {
        head.textContent = '';
        var k = el('span', 'dzc-uh__k', 'Complete your order');
        k.appendChild(el('span', 'dzc-uh__dot', '.'));
        head.appendChild(k);
        head.appendChild(el('span', 'dzc-uh__sub', 'Picked for your cart'));
        head.className = 'related-products__heading dzc-uh';
      }
      if (!track || track.children.length) return;

      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        if (!cart.items || !cart.items.length) return;
        var inCart = cart.items.map(function (i) { return i.product_id; });
        var seed = cart.items[0].product_id;
        return recs(seed, ['complementary', 'related'])
          .then(function (d) {
            var picks = (d.products || []).filter(function (p) {
              return inCart.indexOf(p.id) === -1 && p.available;
            }).slice(0, 2);
            if (!picks.length) { wrap.style.display = 'none'; return; }
            var row = el('div', 'dzc-urow');
            picks.forEach(function (p) {
              var avail = (p.variants || []).filter(function (x) { return x.available; });
              var v = avail[0];
              if (!v) return;
              var card = el('div', 'dzc-ucard');
              var img = p.featured_image || (p.images && p.images[0]) || '';
              card.appendChild(el('div', 'dzc-ucard__img',
                img ? '<img src="' + img + '" alt="" loading="lazy">' : ''));
              card.appendChild(el('div', 'dzc-ucard__n', p.title));
              card.appendChild(el('div', 'dzc-ucard__p', formatMoney(v.price)));
              var btn = el('button', 'dzc-ucard__add', 'Add');
              btn.type = 'button';
              card.appendChild(btn);
              wireAdd(card, btn, p.variants || []);
              row.appendChild(card);
            });
            track.appendChild(row);
          });
      }).catch(function () {});
    } catch (e) {}
  }

  /* Tries each intent in turn and returns the first that yields products.
     'complementary' is the better signal but is empty unless the merchant has
     configured Shopify Search & Discovery, so 'related' is the safety net. */
  function recs(seed, intents) {
    var i = 0;
    function next() {
      if (i >= intents.length) return Promise.resolve({ products: [] });
      var url = '/recommendations/products.json?product_id=' + seed +
                '&limit=8&intent=' + intents[i++];
      return fetch(url).then(function (r) { return r.json(); }).then(function (j) {
        if (j && j.products && j.products.length) return j;
        return next();
      }).catch(next);
    }
    return next();
  }

  /* Adding straight from a recommendation card used to silently pick the first
     available variant — so the shopper got whatever size happened to be first.
     Now a card with more than one available size reveals size pills in place of
     the Add button; one tap adds that exact variant. Single-size products
     (socks, packs) still add in one tap. */
  /* Adding straight from a recommendation card used to silently pick a variant,
     so the shopper got whatever size happened to be first — usually the only one
     left in stock. Now ADD reveals the full size run, exactly like the PDP:
     every size is listed, sold-out ones struck through and unclickable, so the
     shopper can see what the product runs in and what is actually gettable.
     Only genuinely one-size products (socks, packs) skip the step. */
  function wireAdd(card, btn, variants) {
    variants = variants || [];
    var avail = variants.filter(function (v) { return v.available; });
    btn.addEventListener('click', function () {
      if (!avail.length) return;
      if (variants.length <= 1) {
        btn.disabled = true;
        btn.textContent = 'Adding';
        addToCart(avail[0].id, btn);
        return;
      }
      if (card.querySelector('.dzc-sizes')) return;
      var row = el('div', 'dzc-sizes');
      variants.forEach(function (v) {
        var pill = el('button', 'dzc-size' + (v.available ? '' : ' is-oos'), v.title);
        pill.type = 'button';
        if (!v.available) {
          pill.disabled = true;
          pill.setAttribute('aria-disabled', 'true');
          pill.setAttribute('title', 'Sold out');
        } else {
          pill.addEventListener('click', function () {
            var all = row.querySelectorAll('.dzc-size');
            for (var i = 0; i < all.length; i++) all[i].disabled = true;
            pill.classList.add('is-sel');
            addToCart(v.id, btn);
          });
        }
        row.appendChild(pill);
      });
      btn.style.display = 'none';
      card.appendChild(row);
    });
  }

  function formatMoney(cents) {
    try {
      if (window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(cents);
    } catch (e) {}
    return '$' + (cents / 100).toFixed(2);
  }

  /* Routes through the theme's own cart-drawer element so the drawer re-renders
     exactly the way a normal add does. Falls back to a reload only if that API
     is unavailable. */
  function addToCart(variantId, btn) {
    var drawer = document.querySelector('cart-drawer');
    var sections = [];
    try {
      if (drawer && drawer.getSectionsToRender) {
        sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      }
    } catch (e) {}
    var body = { id: variantId, quantity: 1 };
    if (sections.length) {
      body.sections = sections;
      body.sections_url = window.location.pathname;
    }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (res) {
      try {
        if (drawer && drawer.renderContents && res.sections) {
          drawer.renderContents(res);
          return;
        }
      } catch (e) {}
      /* The theme lazy-loads global.min.js until first interaction, so
         <cart-drawer> is often NOT an upgraded custom element yet and
         renderContents does not exist. Rather than reload the whole page,
         re-fetch the drawer section and swap it in, then re-apply structure. */
      swapDrawer(btn);
    }).catch(function () {
      btn.disabled = false;
      btn.textContent = 'Add';
    });
  }

  function swapDrawer(btn) {
    fetch(window.location.pathname + '?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('#CartDrawer');
        var cur = document.querySelector('#CartDrawer');
        if (!fresh || !cur) { window.location.reload(); return; }
        cur.parentNode.replaceChild(fresh, cur);
        run();
        var bubble = document.querySelector('#cart-icon-bubble, .header__icon--cart');
        if (bubble) { document.dispatchEvent(new CustomEvent('cart:refresh')); }
      })
      .catch(function () { window.location.reload(); })
      .then(function () { if (btn) { btn.disabled = false; btn.textContent = 'Add'; } });
  }

  /* ---------- header item count ----------
     The mock puts a muted count beside CART. The theme already prints one in the
     footer (.cart-item-count), so mirror that rather than re-deriving it. */
  function headerCount(root) {
    try {
      var head = root.querySelector('.drawer__heading');
      if (!head) return;
      var src = root.querySelector('.cart-item-count');
      var label = src ? txt(src) : '';
      if (!label) {
        var n = root.querySelectorAll('tr.cart-item').length;
        label = n + (n === 1 ? ' item' : ' items');
      }
      var tag = head.parentNode.querySelector('.dzc-hcount');
      if (!tag) {
        tag = el('span', 'dzc-hcount');
        head.parentNode.insertBefore(tag, head.nextSibling);
      }
      tag.textContent = label;
    } catch (e) {}
  }

  /* ---------- checkout label + trust row ---------- */
  function checkoutBits(root) {
    try {
      var btn = root.querySelector('#CartDrawer-Checkout');
      if (btn && !btn.dataset[DONE]) {
        btn.textContent = 'Secure checkout';
        btn.dataset[DONE] = '1';
      }
      var ctas = root.querySelector('.cart__ctas');
      if (ctas && ctas.parentNode && !ctas.parentNode.querySelector('.dzc-trust')) {
        var lock = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><rect x="5" y="11" width="14" height="9" rx="1.5"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg>';
        var shield = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M12 3l7 3v6c0 4-3 7-7 9-4-2-7-5-7-9V6z"/></svg>';
        var trust = el('div', 'dzc-trust',
          '<span>' + lock + 'Secure checkout</span><span>Shop Pay</span><span>' + shield + '60-day guarantee</span>');
        /* AFTER .cart__ctas, never inside it — see note above. */
        ctas.parentNode.insertBefore(trust, ctas.nextSibling);
      }
    } catch (e) {}
  }

  /* ---------- money: force cents ----------
     The store's money format drops decimals on whole amounts, so the drawer shows
     "$49" next to "$18.99". Display-only normalisation, scoped to the drawer —
     the store setting is untouched. */
  function money(root) {
    try {
      var sel = '.cart-item__price-wrapper .price, .cart-item__price-wrapper s,' +
                ' .dzc-line__total, .dzc-ucard__p, .totals__total-value span,' +
                ' .dzc-save__amt, .dzc-saved';
      var nodes = root.querySelectorAll(sel);
      for (var i = 0; i < nodes.length; i++) {
        var n = nodes[i];
        if (n.querySelector && n.querySelector('*')) continue;
        var v = (n.textContent || '').trim();
        var out = v.replace(/$(d[d,]*)(?![d.,])/g, '$$1.00');
        if (out !== v) n.textContent = out;
      }
    } catch (e) {}
  }

  /* ---------- empty-state CTA ----------
     CONTINUE SHOPPING is painted #8d0000 by one of the store's app stylesheets
     (kaching-bundles / common, both CORS-opaque). That rule beats even a
     1-3-1 selector carrying !important, so the only thing left that outranks it
     is an inline declaration with priority. Verified by measurement, not
     assumed: the CSS rule is present and the element matches it, yet computed
     background stayed #8d0000. Same fight as the checkout button. */
  /* Which collection fills the empty cart. Hardcoded for now because reading a
     theme setting needs Liquid; this becomes settings.cart_drawer_collection
     when the settings work lands. Change this one string to re-point it. */
  var EMPTY_RECS_COLLECTION = 'originalz';

  /* ---------- empty band ----------
     Occupies exactly the slot the savings band uses, so the empty cart keeps
     the same architecture: black header, band, content. Carries the same
     shimmer. The Shop now button just closes the drawer. */
  function emptyBand(root) {
    try {
      if (!root.querySelector('cart-drawer-items.is-empty')) return;
      var outer = root.querySelector('.drawer__header_outer');
      if (!outer || outer.querySelector('.dzc-emptyband')) return;
      var band = el('div', 'dzc-emptyband');
      band.appendChild(el('span', 'dzc-emptyband__txt', 'Your cart is empty.'));
      var b = el('button', 'dzc-emptyband__cta', 'Shop now');
      b.type = 'button';
      b.addEventListener('click', function () {
        var c = root.querySelector('.drawer__close');
        if (c) c.click();
        /* the close button's handler lives in the deferred theme JS, so make
           sure the drawer actually closes either way */
        root.classList.remove('active');
        document.body.classList.remove('overflow-hidden');
      });
      band.appendChild(b);
      outer.appendChild(band);
    } catch (e) {}
  }

  /* ---------- empty-cart recommendations ----------
     The old drawer filled the empty state with four static promo tiles. Those
     are hidden now, but an empty cart is still the best place to put product in
     front of someone — rebuilt with the same card the filled cart uses, so the
     two states are visibly one design. No cart item exists to seed Shopify's
     recommendations endpoint, so this pulls from a collection instead. */
  function emptyRecs(root) {
    var content = root.querySelector('.cart-drawer__empty-content');
    if (!content || content.dataset.dzcRecs) return;
    if (!root.querySelector('cart-drawer-items.is-empty')) return;

    /* DO NOT FETCH UNTIL THE DRAWER IS ACTUALLY OPEN (2026-08-10).

       This used to fire from boot() on EVERY page load, because the empty
       drawer is server-rendered into every page and most visitors arrive with
       an empty cart. Nobody had opened anything — the markup was simply there.

       That made it a second, entirely avoidable caller of a rate-limited
       endpoint at the busiest moment of the page load, competing with
       drawlz-size-bridge.js's own products.json request. Both were answered 429
       and the "Ready in {size}" row silently never rendered. Confirmed in the
       network log: two feed requests fired within milliseconds of each other on
       a collection page, and all four of the bridge's attempts were throttled.

       Nothing about this content is needed before the drawer opens, so wait.
       The class lives on the <cart-drawer> CUSTOM ELEMENT, not on #CartDrawer,
       which is a plain div inside it — Dawn's open() does
       classList.add('animate','active') on the host. Observing the wrong node
       here would silently never fire.

       The existing MutationObserver in boot() only watches childList/subtree,
       so a class flip on the host is invisible to it; hence this second,
       attribute-only observer, registered once per host. */
    var host = root.closest('cart-drawer') || document.querySelector('cart-drawer');
    if (host && !host.classList.contains('active')) {
      if (!host.dataset.dzcRecsWait) {
        host.dataset.dzcRecsWait = '1';
        new MutationObserver(function () {
          if (host.classList.contains('active')) schedule();
        }).observe(host, { attributes: true, attributeFilter: ['class'] });
      }
      return;
    }

    content.dataset.dzcRecs = '1';
    try {
      var wrap = el('div', 'dzc-emptyrecs');
      var head = el('div', 'dzc-uh');
      var k = el('span', 'dzc-uh__k', 'Start your order');
      k.appendChild(el('span', 'dzc-uh__dot', '.'));
      head.appendChild(k);
      head.appendChild(el('span', 'dzc-uh__sub', 'Popular right now'));
      wrap.appendChild(head);
      var row = el('div', 'dzc-urow');
      wrap.appendChild(row);
      content.appendChild(wrap);

      fetch('/collections/' + EMPTY_RECS_COLLECTION + '/products.json?limit=12')
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var picks = (d.products || []).filter(function (p) {
            return (p.variants || []).some(function (v) { return v.available; });
          }).slice(0, 2);
          if (!picks.length) { wrap.style.display = 'none'; return; }
          picks.forEach(function (p) {
            var v = (p.variants || []).filter(function (x) { return x.available; })[0];
            if (!v) return;
            var card = el('div', 'dzc-ucard');
            var img = (p.images && p.images[0] && p.images[0].src) || '';
            card.appendChild(el('div', 'dzc-ucard__img',
              img ? '<img src="' + img + '" alt="" loading="lazy">' : ''));
            card.appendChild(el('div', 'dzc-ucard__n', p.title));
            card.appendChild(el('div', 'dzc-ucard__p', priceText(v.price)));
            var btn = el('button', 'dzc-ucard__add', 'Add');
            btn.type = 'button';
            card.appendChild(btn);
            wireAdd(card, btn, p.variants || []);
            row.appendChild(card);
          });
        }).catch(function () { wrap.style.display = 'none'; });
    } catch (e) {}
  }

  /* /products.json returns price as a decimal STRING ("27.00"), unlike the cart
     API which returns cents. Handle both so the two card paths agree. */
  function priceText(p) {
    if (typeof p === 'string') return '$' + parseFloat(p).toFixed(2);
    return formatMoney(p);
  }

  /* ---------- empty state CTA ----------
     The empty cart must read as the same cart, so the footer stays and its
     button simply changes job: "Add products to checkout", disabled. The
     theme's own CONTINUE SHOPPING and its four legacy promo tiles are hidden in
     CSS — they were the last of the old drawer's design. */
  function emptyCta(root) {
    try {
      var isEmpty = !!root.querySelector('cart-drawer-items.is-empty');
      var chk = root.querySelector('#CartDrawer-Checkout');
      if (!chk) return;
      if (isEmpty) {
        chk.textContent = 'Add products to checkout';
        chk.setAttribute('disabled', 'disabled');
        chk.setAttribute('aria-disabled', 'true');
      } else if (chk.getAttribute('aria-disabled')) {
        chk.removeAttribute('disabled');
        chk.removeAttribute('aria-disabled');
        chk.textContent = 'Secure checkout';
      }
    } catch (err) {}
  }

  /* ---------- remove, before the theme's JS wakes up ----------
     <cart-remove-button> gets its click handler from global.min.js, which this
     theme defers until the first user interaction. The user's first click on the
     x IS that interaction, so it is spent waking the scripts and the removal
     never fires — most visible with a single line item, where nothing happens.
     Delegated in the capture phase: if the element is not yet defined we do the
     change ourselves; once it is defined we step aside and let the theme handle
     it, so a line is never removed twice. */
  function bindRemove(root) {
    if (root.dataset.dzcRemove) return;
    root.dataset.dzcRemove = '1';
    root.addEventListener('click', function (e) {
      var host = e.target.closest ? e.target.closest('cart-remove-button') : null;
      if (!host) return;
      if (customElements.get('cart-remove-button')) return;
      var idx = parseInt(host.getAttribute('data-index'), 10);
      if (!idx) return;
      e.preventDefault();
      e.stopPropagation();
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: idx, quantity: 0 })
      }).then(function () { swapDrawer(null); })
        .catch(function () { window.location.reload(); });
    }, true);
  }

  /* ---------- run + re-run on every re-render ---------- */
  function run() {
    var root = document.querySelector('#CartDrawer');
    if (!root) return;
    restructureSavings(root);
    restructureItems(root);
    footerNote(root);
    upsell(root);
    headerCount(root);
    checkoutBits(root);
    money(root);
    bindRemove(root);
    /* Empty state renders a different tree: .drawer__inner-empty appears BEFORE
       .drawer__header_outer, so the real header is pushed to the bottom and a
       legacy .cart-drawer_header_part shows at the top instead. Flag it and let
       CSS reorder and suppress the legacy blocks. */
    emptyCta(root);
    emptyBand(root);
    emptyRecs(root);
    root.classList.toggle('dzc-empty', !!root.querySelector('cart-drawer-items.is-empty'));
  }

  var t = null;
  function schedule() { clearTimeout(t); t = setTimeout(run, 40); }

  function boot() {
    run();
    var host = document.querySelector('#shopify-section-cart-drawer') ||
               document.querySelector('cart-drawer');
    if (!host) return;
    new MutationObserver(schedule).observe(host, { childList: true, subtree: true });
    document.addEventListener('cart:refresh', schedule);
    document.addEventListener('cart:updated', schedule);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
